<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
      <div class="drawer-wrapper" v-if="isShowIcon">
        <BroswerIcon @click.native="handleClick('UP')" class="icon-wrapper" />
      </div>
    </div>
  </a-config-provider>
</template>
<script>
import * as dd from 'dingtalk-jsapi'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import BroswerIcon from '@/components/BrowersIcon'
export default {
  name: 'App',
  components: {
    BroswerIcon,
  },
  data() {
    return {
      locale: zhCN,
    }
  },
  computed: {
    isShowIcon() {
      console.log('window', window.location.href, this.$route.path)
      return dd.env.platform !== 'notInDingTalk' && this.$route.path === '/mainhome'
    },
  },
  watch: {
    $route(to) {
      let arr = to.path.split('/')
      if (arr.length >= 2 && arr[1] === 'zcm') {
        this.$store.commit('setting/setSystemName', '招财猫')
        this.$store.commit('setting/setSystemLogo', '/static/img/zcmlogonew.png')
      }
    },
  },
  created() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.drawer-wrapper {
  position: absolute;
  cursor: pointer;
  top: 5px;
  right: 5px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue